import React from 'react';
import PropTypes from 'prop-types';
import Header from 'cccisd-header';
import style from './style.css';

const Appdefs = window.cccisd.appDefs;
const Fortress = window.cccisd.fortress;

const NavBar = ({ className, noLogoLink }) => {
    let primaryNavLinks = [];
    try {
        primaryNavLinks = Appdefs.navs.find(n => n.handle === 'header').nav.map(({ label, url }) => ({ label, url }));
    } catch (e) {
        // no header nav for this role, leave it empty
    }

    if (Fortress.auth() && Fortress.user.acting.role.handle === 'questprojectadmin') {
        primaryNavLinks.push({ label: 'Quest', url: '/quest' });
    }

    return (
        <div className={style.header}>
            <Header
                containerClassName={className}
                logoClassName={style.logo}
                logoLink={noLogoLink ? null : '/'}
                primaryNavLinks={primaryNavLinks}
            />
        </div>
    );
};

NavBar.defaultProps = {
    className: 'container',
    noLogoLink: false,
};

NavBar.propTypes = {
    className: PropTypes.string,
    noLogoLink: PropTypes.bool,
};

export default NavBar;
